/*
  Card de produto no visual do lançamento (snippets/product-card-launch.liquid).
  Troca de variante (preço, riscado, selo, % da assinatura, botões) e adicionar ao
  carrinho via /cart/add.js abrindo o cart drawer.
  Pode ser incluído mais de uma vez na página: cada form é ligado uma vez só.
*/
(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function cartAddUrl() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  function bind(form) {
    if (form.dataset.launchBound) return;
    form.dataset.launchBound = 'true';

    var card = form.closest('.launch-card');
    var variants = JSON.parse(form.querySelector('[data-launch-variants]').textContent);
    var idInput = form.querySelector('[data-launch-variant-id]');
    var typeInput = form.querySelector('[data-launch-purchase-type]');
    var buttons = form.querySelectorAll('[data-launch-submit]');
    var priceEl = card.querySelector('[data-launch-price]');
    var compareEl = card.querySelector('[data-launch-compare]');
    var badgeEl = card.querySelector('[data-launch-discount-badge]');
    var promoEl = card.querySelector('[data-launch-promo-badge]');
    var variantImage = card.querySelector('.launch-card__variant-image');
    var promoPctEl = promoEl && promoEl.querySelector('[data-launch-promo-pct]');
    var source = form.dataset.amplitudeSource || 'Coleção Lançamento';

    function current() {
      return variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    }

    function render() {
      var v = current();
      var price = Math.round(v.price * (100 - v.oneTime) / 100);
      var compare = v.oneTime > 0 ? v.price : (v.compareAtPrice > v.price ? v.compareAtPrice : 0);
      priceEl.textContent = formatMoney(price);
      compareEl.textContent = compare ? formatMoney(compare) : '';
      compareEl.hidden = !compare;
      if (badgeEl && !badgeEl.hasAttribute('data-badge-override')) {
        var pct = v.hasSubscription ? v.subscription : v.oneTime;
        badgeEl.textContent = 'até ' + pct + '%';
        badgeEl.hidden = !(pct > 0);
      }
      // Card por variante: foto acompanha a variante escolhida.
      if (variantImage && v.image) {
        variantImage.removeAttribute('srcset');
        variantImage.src = v.image;
      }
      // Selo de campanha: desconto atual (preço exibido vs. riscado); sem ele, o da assinatura.
      if (promoPctEl) {
        var off = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
        if (!off && v.hasSubscription) off = v.subscription;
        promoPctEl.textContent = off + '%';
        promoEl.hidden = !(off > 0);
      }
      buttons.forEach(function (button) {
        button.disabled = !v.available || (button.dataset.launchSubmit === 'subscription' && !v.sellingPlan);
      });
    }

    card.querySelectorAll('[data-launch-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        idInput.value = radio.value;
        render();
      });
    });

    // O tipo de compra é gravado no clique (antes do submit) porque o modal
    // de pré-venda reenvia o form com requestSubmit(), sem o botão original.
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        typeInput.value = button.dataset.launchSubmit;
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var v = current();
      var type = typeInput.value;
      var button = form.querySelector('[data-launch-submit="' + type + '"]');
      var formData = new FormData();
      formData.append('id', v.id);
      formData.append('quantity', '1');
      if (type === 'subscription' && v.sellingPlan) formData.append('selling_plan', v.sellingPlan);

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
      }

      if (typeof window.mahtaTrack === 'function') {
        window.mahtaTrack(source + (type === 'subscription' ? ': Assinar Clicado' : ': Comprar Uma Vez Clicado'), {
          produto: form.dataset.productHandle,
          variant_id: v.id
        });
      }

      if (button) button.setAttribute('aria-busy', 'true');
      fetch(cartAddUrl(), { method: 'POST', body: formData })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (drawer && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else if (drawer) {
            drawer.open();
          } else {
            window.location = window.routes ? window.routes.cart_url : '/cart';
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-card-launch', productVariantId: v.id, cartData: data });
          }
        })
        .catch(function (error) {
          console.error('[product-card-launch] Erro ao adicionar ao carrinho:', error);
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-launch-form]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
